import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../App";
import { toast } from "sonner";
import { ClockCounterClockwise, User } from "@phosphor-icons/react";

const HistoricoPage = () => {
    const [dates, setDates] = useState([]);
    const [selected, setSelected] = useState(null);
    const [obras, setObras] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const res = await axios.get(`${API}/assignments/dates`);
                const ds = res.data.dates || [];
                setDates(ds);
                setSelected(ds[0] || new Date().toISOString().slice(0, 10));
            } catch (e) {
                toast.error("Error al cargar el histórico");
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    useEffect(() => {
        if (!selected) return;
        (async () => {
            try {
                const res = await axios.get(`${API}/assignments/history`, { params: { date: selected } });
                setObras(res.data.obras || []);
            } catch (e) {
                toast.error("Error al cargar el reparto de esa fecha");
            }
        })();
    }, [selected]);

    const fmtFecha = (iso) => {
        const [y, m, d] = iso.split("-").map(Number);
        return new Date(y, m - 1, d).toLocaleDateString("es-ES", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
    };
    const fmtHora = (iso) => (iso ? new Date(iso).toLocaleString("es-ES") : "");

    if (loading) {
        return <div className="flex items-center justify-center h-64"><div className="spinner"></div></div>;
    }

    return (
        <div className="space-y-6 animate-in" data-testid="historico-page">
            <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#0055FF] rounded-sm flex items-center justify-center">
                    <ClockCounterClockwise size={28} weight="fill" className="text-white" />
                </div>
                <div>
                    <h1 className="font-heading font-bold text-2xl md:text-3xl">Histórico de repartos</h1>
                    <p className="text-[#555555]">Consulta el reparto de cualquier día para auditar quién trabajó dónde.</p>
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-[240px_1fr] gap-6">
                {/* Lista de fechas */}
                <div className="bg-white border border-[#E5E5E5] rounded-sm p-2 max-h-[70vh] overflow-y-auto">
                    {dates.length === 0 ? (
                        <p className="text-sm text-[#999] p-3">Aún no hay repartos guardados.</p>
                    ) : (
                        dates.map((d) => (
                            <button
                                key={d}
                                onClick={() => setSelected(d)}
                                className={`w-full text-left px-3 py-2 rounded-sm text-sm mb-1 ${
                                    selected === d ? "bg-[#0055FF] text-white" : "hover:bg-[#F8F9FA]"
                                }`}
                            >
                                {d}
                            </button>
                        ))
                    )}
                </div>

                {/* Reparto del día seleccionado */}
                <div className="space-y-4">
                    {selected && (
                        <h2 className="font-heading font-bold text-xl capitalize">{fmtFecha(selected)}</h2>
                    )}
                    {obras.length === 0 ? (
                        <div className="bg-white border border-[#E5E5E5] rounded-sm p-8 text-center text-[#555555]">
                            No hay reparto registrado para esta fecha.
                        </div>
                    ) : (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {obras.map((o, i) => (
                                <div key={i} className="bg-white border border-[#E5E5E5] rounded-sm">
                                    <div className="p-4 border-b border-[#E5E5E5] flex items-center justify-between">
                                        <h3 className="font-heading font-bold">{o.project_name}</h3>
                                        <span className="text-xs font-bold px-2 py-1 rounded-sm bg-[#F0F4FF] text-[#0055FF]">
                                            {o.operarios.length} operario{o.operarios.length === 1 ? "" : "s"}
                                        </span>
                                    </div>
                                    <div className="p-4 space-y-1">
                                        {o.operarios.map((op, j) => (
                                            <div key={j} className="flex items-start gap-2 text-sm">
                                                <User size={16} className="text-[#999] mt-0.5 shrink-0" />
                                                <span>
                                                    {op.name}
                                                    {op.note && <span className="text-[#999]"> — {op.note}</span>}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="px-4 py-2 border-t border-[#F0F0F0] text-xs text-[#999]">
                                        {o.inherited
                                            ? `Heredado del reparto del ${o.from_date}`
                                            : `Guardado${o.updated_by ? ` por ${o.updated_by}` : ""}${o.updated_at ? ` · ${fmtHora(o.updated_at)}` : ""}`}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default HistoricoPage;
